(() => {
  // app/scripts/utils/dataToXLSX.js
  function exportToXLSX(data, headers, name, tabName) {
    const worksheet = XLSX.utils.json_to_sheet(data);
    XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: "A1" });
    XLSX.utils.sheet_add_json(worksheet, data, { origin: "A2", skipHeader: true });
    const workbook = XLSX.utils.book_new();
    const cleanTabName = tabName.replace(/[\[\]*?\/\\:]/g, "").substring(0, 31);
    XLSX.utils.book_append_sheet(workbook, worksheet, cleanTabName);
    const cleanFileName = name.replace(/[\\/:*?"<>|]/g, "_");
    XLSX.writeFile(workbook, `${cleanFileName}.xlsx`);
  }

  // app/scripts/export-cart.js
  var { getVariantsInfo } = theme.utils;
  var {
    exportItems: {
      manufacture: manufactureString,
      quantity: quantityString,
      price: priceString,
      cartTabName,
      cartFileName
    }
  } = theme.string;
  var ExportCart = class extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.addEventListener("click", this.handleClick.bind(this));
    }
    async handleClick(event) {
      try {
        this.classList.add("is-loading");
        const cartValue = await Cart.value();
        const variantIds = cartValue.items.map((item) => item.variant_id);
        const variantInfoList = await getVariantsInfo(variantIds);
        const newVariantInfoList = cartValue.items.map(({ variant_id, quantity, properties }) => {
          const variantInfo = variantInfoList[variant_id];
          if (!variantInfo)
            return null;
          const price = properties._b2b_price ? Number(properties._b2b_price) : Number(properties._unitPrice);
          return {
            ...variantInfo,
            quantity: properties._quantity || quantity,
            Price: Number(price) + (Number(properties._ecofee) || 0)
          };
        }).filter(Boolean).reverse();
        const dataToExport = newVariantInfoList.map(({ quantity, manufacture, Price }) => ({
          [manufactureString]: manufacture,
          [quantityString]: quantity,
          [priceString]: Price
        }));
        exportToXLSX(dataToExport, [manufactureString, quantityString, priceString], cartFileName, cartTabName);
      } catch (error) {
        throw error;
      } finally {
        this.classList.remove("is-loading");
      }
    }
  };
  customElements.define("export-cart", ExportCart);
})();
